





























































import Reflect from "reflect-metadata";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { User } from "@/models/User";
import userService from "@/services/UserService";
import messageService from "@/services/MessageService";
import { SearchFilters } from "../services/SearchService";
import contactService from "@/services/ContactService";
import { Contact } from "@/models/Contact";

@Component
export default class UserFiltersDialog extends Vue {
  @Prop({ default: "" })
  filterName!: string;

  @Prop({ default: "text" })
  filterType!: string;

  @Prop({ default: "" })
  title!: string;

  filterValue: string = "";
  filterLabel!: string;
  loading: boolean = false;
  isOpen: boolean = false;

  contacts: Contact[] = [];
  selectedContact: Partial<Contact> = {};

  @Watch("selectedContact")
  onContactSelect() {
    this.filterValue = String(this.selectedContact.id);
    this.filterLabel = this.selectedContact.name as string;
  }

  mounted() {
    (this.$refs.input as HTMLInputElement).focus();
    if (this.filterType == "autocomplete") {
      this.loadContacts();
    }
  }

  updated() {
    (this.$refs.input as HTMLInputElement).focus();
  }

  /**
   * Fetches available contacts filtered by user input with debounce
   */
  loadContacts() {
    this.loading = true;
    contactService
      .get({ name: this.filterValue })
      .then(response => {
        this.contacts = response.data as Contact[];
      })
      .finally(() => {
        this.loading = false;
      });
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
    this.filterValue = "";
  }

  cancelFilter() {
    this.$root.$emit("filter:cancel");
    this.isOpen = false;
  }

  applyFilter() {
    if (this.filterValue && this.filterValue != "") {
      this.$root.$emit("filter:apply", [
        {
          value: this.filterValue,
          key: this.filterName,
          label: this.filterLabel || this.filterValue
        }
      ]);
      this.isOpen = false;
    }
  }
}
